/**
 * Periodo de mortalidad ensilada: UI con rango (DatePicker) → string único
 * para glosa DscItem y res_guide_detail (mismo contrato que el Input de texto).
 */

const pad = n => String(n).padStart(2, '0');

function formatOneDate(d) {
	if (!d) return '';
	const x = d instanceof Date ? d : new Date(d);
	if (Number.isNaN(x.getTime())) return '';
	return `${pad(x.getDate())}/${pad(x.getMonth() + 1)}/${x.getFullYear()}`;
}

/**
 * @param {[Date|null, Date|null]|null|undefined} dates - valor típico de Mantine range
 * @returns {string} ej. "01/03/2024 al 15/03/2024" o "" si vacío
 */
export function serializePeriodRange(dates) {
	if (!dates || !Array.isArray(dates)) return '';
	const [a, b] = dates;
	if (!a && !b) return '';
	const s1 = formatOneDate(a);
	const s2 = formatOneDate(b);
	if (s1 && s2) return `${s1} al ${s2}`;
	if (s1) return s1;
	return '';
}

/**
 * Intenta interpretar texto libre previo o nuestro formato "DD/MM/YYYY al DD/MM/YYYY".
 * @returns {[Date|null, Date|null]}
 */
export function parsePeriodStringToRange(str) {
	if (!str || typeof str !== 'string') return [null, null];
	const t = str.trim();
	if (!t) return [null, null];

	const parseChunk = chunk => {
		const m = chunk.trim().match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
		if (!m) return null;
		const day = Number(m[1]);
		const month = Number(m[2]) - 1;
		const year = Number(m[3]);
		const dt = new Date(year, month, day);
		if (
			dt.getFullYear() !== year ||
			dt.getMonth() !== month ||
			dt.getDate() !== day
		) {
			return null;
		}
		return dt;
	};

	const parts = t.split(/\s+al\s+/i);
	if (parts.length === 2) {
		const d1 = parseChunk(parts[0]);
		const d2 = parseChunk(parts[1]);
		return [d1, d2];
	}

	const one = parseChunk(t);
	return one ? [one, null] : [null, null];
}
